import type { ModelsResolver } from "@/models/resolvers";
import { revisionDefaultFields } from "@/models/resolvers";
import { useLogger } from "@/composables/logger";

const { info: logInfo } = useLogger("SCENARIOS_PARAMETERS_RESOLVER");

export default {
  optimistic: {
    insert_revisions_scenario_parameters_revisions(vars, cache, info) {
      logInfo("Optimistic", { vars, cache, info });
      const affectedRows = vars.objects.length;

      return {
        __typename: "revisions_scenario_parameters_revisions_mutation_response",
        affected_rows: affectedRows,
        returning: vars.objects.map(obj => ({
          id: obj.id,
          __typename: "revisions_scenario_parameters_revisions",
          scenario_parameters_view: {
            ...obj,
            ...revisionDefaultFields(obj),
            __typename: "scenario_parameters"
          }
        }))
      };
    }
  }
} as ModelsResolver;
